/* SOULLIX SECTIONS — procentcirkler der taeller op naar de kommer i syne. */
(function () {
  'use strict';

  var CIRCUMFERENCE = 2 * Math.PI * 52; // r = 52 i SVG'ens viewBox
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fill(ring) {
    var pct = Math.max(0, Math.min(100, parseFloat(ring.dataset.sxRing) || 0));
    var arc = ring.querySelector('.sxsu__ring-fg');
    var num = ring.querySelector('[data-sx-ring-num]');

    if (arc) arc.style.strokeDashoffset = CIRCUMFERENCE * (1 - pct / 100);

    if (!num) return;

    if (reduce) { num.textContent = Math.round(pct) + '%'; return; }

    var start = performance.now();
    var dur = 1200;

    (function step(now) {
      var p = Math.min((now - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      num.textContent = Math.round(pct * eased) + '%';
      if (p < 1) requestAnimationFrame(step);
    })(start);
  }

  function init(scope) {
    var rings = (scope || document).querySelectorAll('[data-sx-ring]:not([data-sx-ring-ready])');
    if (!rings.length) return;

    if (!('IntersectionObserver' in window)) {
      rings.forEach(function (r) { r.setAttribute('data-sx-ring-ready', '1'); fill(r); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        fill(e.target);
      });
    }, { threshold: 0.35 });

    rings.forEach(function (r) { r.setAttribute('data-sx-ring-ready', '1'); io.observe(r); });
  }

  /* Smaa videoer i undersoegelsen: hent og afspil foerst naar de er i syne,
     og saet dem paa pause igen naar de ruller ud. Sparer data paa mobil. */
  function initVideos(scope) {
    var vids = (scope || document).querySelectorAll('.sxsu__clip video:not([data-sx-vid-ready])');
    if (!vids.length) return;

    function play(v) {
      if (!v.getAttribute('src') && v.dataset.sxSrc) v.src = v.dataset.sxSrc;
      v.muted = true;
      if (v.preload === 'none') v.preload = 'auto';
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    if (reduce || !('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.setAttribute('data-sx-vid-ready', '1'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { threshold: 0.25 });

    vids.forEach(function (v) {
      v.setAttribute('data-sx-vid-ready', '1');
      v.muted = true;
      v.setAttribute('muted', '');
      io.observe(v);
    });
  }

  init(document);
  initVideos(document);

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    initVideos(e.target);
  });
})();
